import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0B0C10] text-slate-100 flex items-center justify-center p-6">
      <div className="text-center">
        <XCircle className="w-16 h-16 text-[#FF1744] mx-auto" />
        <h1 className="mt-6 text-4xl font-black" style={{ fontFamily: "Unbounded, sans-serif" }}>Betaling geannuleerd</h1>
        <p className="mt-3 text-slate-400">Geen zorg — er is niets afgeschreven.</p>
        <Link to="/viewer" className="mt-8 inline-block px-5 py-3 rounded-lg bg-[#FFD700] text-[#0B0C10] font-bold">Opnieuw proberen</Link>
      </div>
    </div>
  );
}
